<template>
  <a-layout class='index animated fadeIn'>
    <a-card class="m-t-10" :bordered='false'>
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      <span class="ml15 card_title" v-if='$route.query.type == "look"'>业务员详情</span>
      <span class="ml15 card_title" v-else>{{$route.query.type == 'add' ? '添加':'修改'}}业务员</span>
    </a-card>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="sale_name" label="业务员名称" name="sale_name">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.sale_name" :disabled='$route.query.type == "look"' :maxlength="10" placeholder='请输入业务员名称' />
            </a-col>
            <a-col :span="12">
              <p>（最多10个字）</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="account" label="手机号码" name="account">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.account" :disabled='$route.query.type != "add"' :maxlength='11' placeholder='请输入业务员联系人手机号码' />
            </a-col>
            <a-col :span="12">
              <p> <span style="color:#f04635;font-weight:600;font-size:13px">（登录账号,请谨慎操作）</span> </p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="password" label="设置密码" name="password" v-if='$route.query.type == "add"'>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input-password v-model:value="form.password" placeholder='请输入密码' />
            </a-col>
            <a-col :span="12">
              <p>6-20个非中文字符</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="职级" name='sale_rank_id'>
          <rankSelect v-model:value="form.sale_rank_id"  :style="{width:'280px'}" :disabled='$route.query.type == "look"' />
          <!-- <a-select v-model:value="form.sale_rank_id" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select> -->
        </a-form-item>
        <a-form-item ref=""  label="管辖大区" name="">
          <a-row :gutter="16">
            <a-col :span="12">
              <div class="s_bor10 p-5 height-160" style="overflow-x: auto;overflow-y:scroll;border:1px solid #ccc">
                <div class="s_flex_bian_c s_bf58 bor-rad-5 p-tb0-lr10 m-b-10" v-for='(item,index) in dealerAreaList' :key='index'>
                  <p>{{item.sale_cat_name}}</p>
                  <CloseCircleFilled class="s_c999" v-if='$route.query.type == "look"' />
                  <CloseCircleFilled class="s_c999" @click='delAreaDealer(index)' v-else />
                </div>
              </div>
            </a-col>
            <a-col :span="12">
              <a-button type="primary" @click='showDealerArea = true' v-if='$route.query.type != "look"'>
                选择
              </a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="up_name"  label="管辖经销商"  :wrapper-col="{span:20}">
          <div>
            <a-button type="primary" @click='showDealer = true' v-if="$route.query.type != 'look'">
              选择经销商
            </a-button>
          </div>
          <div>
            <a-table :pagination='false' :loading='listLoading' bordered rowKey='dealer_id' :columns='columns' :data-source='dealerList' class="tableFixBox" >
              <template v-slot:action="{ index }">
                <a v-has:dealerDel="()=>delDealer(index)" href="javascript:;" v-if="$route.query.type != 'look'">删除</a>
              </template>
            </a-table>
                 <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper v-if="$route.query.id"
              :current="dealerSearch.page" :page-size="dealerSearch.limit" :total="dealerSearch.total" @change="pageCurrentChange"
              @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `" />
          </div>
        </a-form-item>
        <a-form-item class="m-t-25" :wrapper-col="{ span: 8, offset: 2 }" v-if='$route.query.type !== "look"'>
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
  <a-modal :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1300' :footer="null" destroyOnClose>
    <selectDealer v-on:select="dealerSelect"  :selectList="dealerList"  :selectIds="form.dealer_ids" :checkout="true" :parent_dealer_id="0" ></selectDealer>
  </a-modal>
  <a-modal :keyboard="false" title="选择销售区" centered v-model:visible="showDealerArea" :width='1300' :footer="null" destroyOnClose>
    <selectDealerArea v-on:select="dealerAreaSelect"   :selectList="dealerAreaList"  :checkout="true"></selectDealerArea>
  </a-modal>
  
</template>
<script>
import { LeftOutlined, CloseCircleFilled } from "@ant-design/icons-vue";
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import { message } from "ant-design-vue";
import store from "@/store";
import {createBrandSale,getBrandSaleDetail,updateBrandSale,getBrandSaleDealer} from '@/api/salesman'
import { iscode } from "@/utils/app";
const columns = [
  {
    title: "经销商编号",
    dataIndex: "dealer_sn",
    key: "dealer_sn",
  },
  {
    title: "经销商名称",
    dataIndex: "dealer_name",
    key: "dealer_name",
  },
  {
    title: "经销商地址",
    dataIndex: "address",
    key: "address",
     customRender: ({ record }) => {
          return record.address || record.area;
    },
  },
  {
    title: "负责人",
    dataIndex: "leader_name",
    key: "leader_name",
  },
  {
    title: "操作",
    key: "action",
    width: 100,
    slots: { customRender: "action" },
  },
];
// 初始化默认筛选项数值
let defForm = {
  sale_name: "",
  account: "",
  password: 123456,
  sale_rank_id: "",
  sale_cat_ids: [],
  dealer_ids: []
};
export default {
  components: {
    LeftOutlined,
    CloseCircleFilled,
  },
  setup() {
    //pass
    const form = ref({ ...defForm });
    const state = reactive({
      info: store.state.user.info,
      showDealer: false,//选择经销商
      loading: false,
      labelCol: { span: 2 },
      wrapperCol: { span: 10 },
      showDealerArea:false,//选择销售大区
      dealerList:[],//已选择的经销商列表
      dealerAreaList:[],//已选择大区列表
      rules: {
        sale_name: [
          { required: true, message: "请输入业务员名称" },
          { max: 20, message: "最多20个字符", trigger: "blur" },
        ],
        account: [{ required: true, message: "请输入手机号码" }],
        password: [{ required: true, message: "请输入密码" }],
        sale_rank_id: [{ required: true, message: "请选择职级" }],
      },
    });
    const ruleForm = ref();
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const $router = inject("$router");
    const _lodash = inject("_lodash");
    // 选择销售大区
      const dealerAreaSelect =async (e) => {
      state.dealerAreaList=e
      state.showDealerArea = false;
    };
     const delAreaDealer=async(index)=>{
      state.dealerAreaList.splice(index,1)
    }
    //选择经销商
    const dealerSelect =async (e) => {
      if(!$route.query.id){
           state.dealerList=e
      }else{
        // 得到的是基于  dealerList 的IDS
        //  var ids=
         form.value.dealer_ids=form.value.dealer_ids.concat(e.map(v=>v.id || v.dealer_id))
       await  updateData()
        getMore()

      }
      state.showDealer = false;
    };
    const delDealer=async (index)=>{

  
      if($route.query.id){
      var dealer_id=state.dealerList[index].id ||state.dealerList[index].dealer_id
       form.value.dealer_ids.splice(form.value.dealer_ids.indexOf(dealer_id),1) 
        await updateData()
        getMore()
      }
      state.dealerList.splice(index,1)
    }
    const getMore = async (id) => {
      const hide = message.loading("正在加载中...", 0);
      let res = await getBrandSaleDetail($route.query.id,{id:$route.query.id}).then((res) => res.data);
        setTimeout(hide);
      if (iscode(res)) {
        form.value = res.data;
        // 根据ID 获取管辖经销商
        getSaleDealer(id)
        // 整理 管辖大区数据
        state.dealerAreaList=[]
        for (const key in res.data.sale_cat_text) {
              state.dealerAreaList.push({
              id:key,
              sale_cat_name:res.data.sale_cat_text[key]
            })
        }
       

        setTimeout(hide);
      } else {
        message.error(res.msg);
      }
    };
    // 获取管辖经销商
    const dealerSearch=ref({
        page:1,
        limit:10,
        total:0
    })
    var getSaleDealer=async ()=>{
        let dealerResult=await getBrandSaleDealer($route.query.id,dealerSearch.value).then(res=>res.data).catch(error=>error)
        state.dealerList=dealerResult.data.data
        dealerSearch.value.total=dealerResult.data.total
       form.value.sale_cat_ids=state.dealerAreaList.map(v=>v.id)

    }
          // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
        dealerSearch.value.page = page;
        getSaleDealer();
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        dealerSearch.value.page = 1;
        dealerSearch.value.limit = limit;
        getSaleDealer();
      };
      var updateData= ()=>{
        return updateBrandSale($route.query.id, form.value).then(res=>res.data).catch(error=>error)
      }
    const onSubmit = () => {
        if(!state.dealerAreaList.length&&!state.dealerList.length){
        message.error('管辖大区或经销商需要选择其一')
        return
      }
      ruleForm.value
        .validate()
        .then(async () => {
          let res;
          const hide = message.loading("正在加载中...", 0);
          form.value.dealer_ids=state.dealerList.map(v=>v.id || v.dealer_id)
          form.value.sale_cat_ids=state.dealerAreaList.map(v=>v.id)
          if ($route.query.type == "add") {
            res = await createBrandSale(form.value).then((res) => res.data);
          } else {
            res = await updateBrandSale($route.query.id,form.value).then(
              (res) => res.data
            );
          }
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            $router.go(-1);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    
    onMounted(async () => {
      if ($route.query.type == "edit" || $route.query.type == "look") {
        getMore($route.query.id);
      }
      if ($route.query.type == "add") {
        let rulesObj = {
          password: [{ required: true, message: "请输入密码" }],
        };
        state.rules = _lodash.merge(state.rules, rulesObj);
      }
    });
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
      confirm,
      dealerSelect,
      dealerAreaSelect,
      columns,
      delAreaDealer,
      delDealer,
      pageSizeChange,
      pageCurrentChange,
      dealerSearch
    };
  },
};
</script>
<style>
.region_list span:last-child .don {
  display: none;
}
</style>